import { Paths, ProjectPathParams } from '../../../app/router/app.router';
import { LoadingIndicator } from '../../../ui/components/pure/loading-indicator/loading-indicator.component';
import { WindowTitle } from '../../../core/window-title/window-title.component';
import { useLockersList } from './hooks/use-lockers-list.hook';
import { ListPageHeader } from '../../../ui/components/pure/page-headers/list/list-page-header.component';
import { ErrorFullPage } from '../../../ui/components/pure/errors/error-full-page/error-full-page.component';
import { LockersListActionsObserver } from './hubs-list-actions-observer.component';
import { HubDetailsCard } from './components/hub-details-card.component';
import { Container } from '@mui/material';

export function HubsList({ params }: { params: ProjectPathParams<Paths.hubs> }) {
  const { project, hubs, actions, state, onSelectSide, sideSelectOptionsByHub } = useLockersList(params.projectID);
  const error = hubs.error;

  if (error) {
    if (error.statusCode === 401) {
      return <ErrorFullPage preset="GLOBAL_ACCESS_DENIED" />;
    }

    if (error.statusCode === 403) {
      return <ErrorFullPage preset="ACCESS_DENIED" entity="area" />;
    }

    if (error.statusCode === 404) {
      return <ErrorFullPage preset="NOT_FOUND" entity="project's hubs" />;
    }

    return <ErrorFullPage />;
  }

  if (hubs.isLoading || project.isLoading) {
    return <LoadingIndicator fullPage />;
  }

  const hubCount = hubs.data?.length || 0;
  const hubCountMessage = `${hubCount} Hub${hubCount > 1 ? 's' : ''}`;
  const hubCardSubtitle = hubCount === 0 ? 'No hubs configured on this project' : hubCountMessage;

  return (
    <Container>
      {project.data && <WindowTitle detail={project.data.name} pageTitle="Hubs" />}
      <ListPageHeader title={project.data?.name || 'Hubs'} subtitle={hubCardSubtitle} />
      {hubs.data?.map(({ hubDetails, hubDto }) => (
        <HubDetailsCard
          key={hubDto.id}
          projectID={params.projectID}
          hub={hubDto}
          hubDetails={hubDetails}
          deliveryContainerActions={actions}
          onSelectSide={(side: string) => onSelectSide(hubDto.id, side)}
          sideSelectOptions={sideSelectOptionsByHub.find((o) => o.hubID === hubDto.id)?.options ?? []}
          selectedSide={state.selectedDoubleSidedLockerSides.find((s) => s.hubID === hubDto.id)}
          setDeliveryContainerAction={actions.setAction}
        />
      ))}
      <LockersListActionsObserver projectID={params.projectID} actions={actions} />
    </Container>
  );
}
